import React, { useCallback } from 'react';
import classnames from 'classnames';
import ArtStageArrowL from '@wix/da-ds/pkg/Icons/ArtStageArrowL';
import ArtStageArrowR from '@wix/da-ds/pkg/Icons/ArtStageArrowR';
import { useSelector } from 'react-redux';
import { getStashFolder, getStashNext, getStashPrev } from '../../../DeviationPage/redux/selectors';
import BackToStashButton from '../BackToStashButton';
import StashPaddle from './StashPaddle';
import { Url } from '@wix/da-url';
import s from './StashPaddles.scss';
const StashPaddles = ({ className, paddleClassName, iconClassName })=>{
    const next = useSelector(getStashNext);
    const prev = useSelector(getStashPrev);
    const folder = useSelector(getStashFolder);
    const openPrev = useCallback(()=>{
        window.location.assign(Url.stashItemLink(prev !== null && prev !== void 0 ? prev : ''));
    }, [
        prev
    ]);
    const openNext = useCallback(()=>{
        window.location.assign(Url.stashItemLink(next !== null && next !== void 0 ? next : ''));
    }, [
        next
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className)
    }, /*#__PURE__*/ React.createElement(StashPaddle, {
        isEnabled: !!prev,
        className: classnames(s['prev'], paddleClassName),
        onClick: openPrev,
        dataHook: "arrowL"
    }, /*#__PURE__*/ React.createElement(ArtStageArrowL, {
        customSizable: true,
        disableDefaultColors: true,
        className: classnames(s['icon'], iconClassName)
    })), folder && /*#__PURE__*/ React.createElement(BackToStashButton, {
        folder: folder
    }), /*#__PURE__*/ React.createElement(StashPaddle, {
        isEnabled: !!next,
        className: classnames(s['next'], paddleClassName),
        onClick: openNext,
        dataHook: "arrowR"
    }, /*#__PURE__*/ React.createElement(ArtStageArrowR, {
        customSizable: true,
        disableDefaultColors: true,
        className: classnames(s['icon'], iconClassName)
    })));
};
export default StashPaddles;
